import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import {
  useQpmCatalogItemGetQuery,
  useQpmCatalogItemSetConsumablesMutation,
} from "@/services/backend/qpm/catalog/api/catalog-api";
import type { ConsumableLinkDTO } from "@/services/backend/qpm/monitors/types/monitor-snapshot";
import { CatalogConsumablesTable } from "./catalog-edit-consumables-table";

/**
 * Catalog-scoped consumables view.
 */
export function CatalogItemConsumablesComponent({
  catalogItemId,
}: {
  catalogItemId: string;
}) {
  const { data, isLoading, error } = useQpmCatalogItemGetQuery(
    { catalogItemId },
    {
      refetchOnMountOrArgChange: true,
    },
  );

  const [save] = useQpmCatalogItemSetConsumablesMutation();

  const snap = data?.snapshot;

  if (isLoading) {
    return <CatalogConsumablesTable consumableList={[]} />;
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  return (
    <CatalogConsumablesTable
      catalogItemId={catalogItemId}
      consumableList={(snap?.consumables as ConsumableLinkDTO[]) ?? []}
      onSave={async (req) => {
        await save(req).unwrap();
      }}
    />
  );
}
